/**
 *
 * MobileSso
 *
 * @version 1.0.0
 * @author Elia Minozzi
 * @since 18-Jun-2025
 */

import React from 'react'
import PropTypes from 'prop-types'
import formattedMessage from '../modules/languageModule'
import Toggle from 'Hoc/ToggleComponent'
import MerchantModal from '@nexidigital/merchantmodal'
import { openUrl } from 'Utility/globalMethods'

const GoToOldNpgModal = props =>
  <Toggle>
    <MerchantModal
      topBarTitle=' '
      title={formattedMessage.attention}
      primaryAction={() => {
        const searchParams = new URLSearchParams(location.search)
        const ssoURL = decodeURIComponent(searchParams.get('ssoURL'))
        const isFromOldNpgPage = window.location.pathname.includes('/oldnpg')
        openUrl(`${ssoURL}/backoffice/transactions/search`, !isFromOldNpgPage)
      }}
      primaryButtonLabel={formattedMessage.go}
      description={formattedMessage.goToNpgDescriptionModal}
      onClose={window.location.pathname.includes('/oldnpg') ? null : () => props.actions.doHidePopup}
    />
  </Toggle>

GoToOldNpgModal.propTypes = {
  // Add here some propTypes
  actions: PropTypes.object
}

GoToOldNpgModal.defaultProps = {
  // Add here some default propTypes values
  actions: {}
}

export default GoToOldNpgModal
